import React, { useEffect, useMemo, useState } from 'react';
import { Phone, Sparkles } from 'lucide-react';
import { useT } from '../utils/i18n';
import { LiveOrderTicker } from './LiveOrderTicker';
const PHONE_NUMBER = '(206) 619-3742';
const SLOGAN_KEYS = ['announce.slogan.sameDay', 'announce.slogan.bulkDelivery', 'announce.slogan.direct', 'announce.slogan.familyOwned', 'announce.slogan.realTrucks', 'announce.slogan.tacoma'] as const;
type DispatchStatus = {
  isActive: boolean;
  opensIn: string;
  deliveryMessage: string;
};
export function AnnouncementBar() {
  const t = useT();
  const [dispatchStatus, setDispatchStatus] = useState<DispatchStatus>(() => getDispatchStatus());
  const sloganKey = useMemo(() => SLOGAN_KEYS[Math.floor(Math.random() * SLOGAN_KEYS.length)], []);
  useEffect(() => {
    const timer = window.setInterval(() => setDispatchStatus(getDispatchStatus()), 30_000);
    return () => window.clearInterval(timer);
  }, []);
  return <div className="relative z-[60] bg-[#4e4040] px-4 py-1.5 text-white dark:bg-[#2E2121]" data-id="element-157" data-mp="1qaytlpw1wexo">
      <div className="mx-auto flex max-w-7xl items-center gap-2 sm:gap-3" data-id="element-158" data-mp="66p28dufxg91">
        <LiveOrderTicker isDispatchActive={dispatchStatus.isActive} opensIn={dispatchStatus.opensIn} deliveryMessage={dispatchStatus.deliveryMessage} data-id="element-159" data-mp="aawpe6l92o55" />
        {!dispatchStatus.isActive && <div className="hidden min-w-0 shrink items-center gap-2 border-l border-white/15 pl-3 md:flex" data-id="element-160" data-mp="18nhzpla3avz">
            <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#00b774]/10 text-[#00b774]" data-id="element-161" data-mp="oyhu24xrwvf6">
              <Sparkles className="h-3 w-3" aria-hidden="true" data-id="element-162" data-mp="txb8q0osqsgx" />
            </span>
            <p className="truncate text-xs font-medium tracking-wide text-white/65" data-id="element-163" data-mp="f7wzqtp4ud22">
              {t(sloganKey)}
            </p>
          </div>}
        <a href="tel:206-619-3742" aria-label={`Call ${PHONE_NUMBER}`} className="inline-flex h-7 shrink-0 items-center justify-center border-l border-white/20 px-3 text-xs font-semibold tracking-tight text-[#04a05c] transition-colors hover:text-white md:justify-start md:gap-1.5 md:pl-4 md:pr-0 md:text-sm" data-id="element-164" data-mp="k5oojeuhdj21">
          <Phone className="h-4 w-4 text-[#04a05c]" data-id="element-165" data-mp="1hl82m9ig1mc4" />
          <span className="hidden whitespace-nowrap md:inline" data-id="element-166" data-mp="1hmj5m742eq26">{PHONE_NUMBER}</span>
        </a>
      </div>
    </div>;
}
function getDispatchStatus(): DispatchStatus {
  const pacificNow = new Date(new Date().toLocaleString('en-US', {
    timeZone: 'America/Los_Angeles'
  }));
  const day = pacificNow.getDay();
  const hour = pacificNow.getHours();
  const isSaturday = day === 6;
  const isSunday = day === 0;
  const closingHour = isSaturday ? 15 : 17;
  const isActive = !isSunday && hour >= 6 && hour < closingHour;
  if (isActive) return {
    isActive: true,
    opensIn: '',
    deliveryMessage: ''
  };
  const nextOpen = new Date(pacificNow);
  nextOpen.setSeconds(0, 0);
  if (isSunday) {
    nextOpen.setDate(nextOpen.getDate() + 1);
  } else if (hour >= closingHour) {
    nextOpen.setDate(nextOpen.getDate() + (isSaturday ? 2 : day === 5 ? 3 : 1));
  }
  nextOpen.setHours(6, 0, 0, 0);
  const remainingMinutes = Math.max(0, Math.ceil((nextOpen.getTime() - pacificNow.getTime()) / 60_000));
  const hours = Math.floor(remainingMinutes / 60);
  const minutes = remainingMinutes % 60;
  const deliveryMessage = isSaturday || isSunday ? 'Order online for Monday delivery' : 'Order online for next-day delivery';
  return {
    isActive: false,
    opensIn: `Opens in ${hours}h ${minutes}m`,
    deliveryMessage
  };
}